import React from "react";
import {
  Alert,
  Box,
  Button,
  Container,
  ContentLayout,
  Header,
  SpaceBetween,
} from "@cloudscape-design/components";
import { payloadFromToken } from "../api/auth";
import { PRIVILEGED_USERS } from "../constants/auth";

function AdminReportsIndex() {
  const [username, setUsername] = React.useState("");

  React.useEffect(() => {
    const storedToken =
      window.localStorage.getItem("id_token") ||
      window.localStorage.getItem("access_token");

    if (!storedToken) return;

    try {
      const payload = payloadFromToken(storedToken);
      const derivedUsername =
        payload?.["cognito:username"] || payload?.username || payload?.email;
      if (derivedUsername) {
        setUsername(derivedUsername);
      }
    } catch (err) {
      console.debug("Unable to derive username from token", err);
    }
  }, []);

  const isPrivileged = PRIVILEGED_USERS.includes(username);

  if (!isPrivileged) {
    return (
      <ContentLayout header={<Header variant="h1">Reports</Header>}>
        <Container>
          <Alert
            statusIconAriaLabel="Info"
            header="Access restricted"
            variant="info"
          >
            You do not have permission to view admin reports.
          </Alert>
        </Container>
      </ContentLayout>
    );
  }

  return (
    <ContentLayout header={<Header variant="h1">Reports</Header>}>
      <Container>
        <SpaceBetween size="m">
          <Box variant="awsui-key-label">Available reports</Box>
          <Box color="text-body-secondary">
            Explore performance and quality insights for your contact center.
          </Box>
          <SpaceBetween size="s">
            <Box>
              <Box fontWeight="bold">Average scores</Box>
              <Box color="text-body-secondary">
                Compare average quality and sentiment scores across agents.
              </Box>
            </Box>
            <Button variant="primary" href="/admin/reports/scores">
              View average scores
            </Button>
          </SpaceBetween>
        </SpaceBetween>
      </Container>
    </ContentLayout>
  );
}

export default AdminReportsIndex;
